import React, {Fragment, useEffect, useState} from "react";
import {v4} from "uuid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {Checkbox, DialogTitle, FormControlLabel, FormGroup, ListSubheader, Typography} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import {rollStep} from "../../_helper/rollStep";
import {displayMod} from "../../_helper/displayMod";
import {rollerSetRolled} from "../../_helper/rollBehave";
import {
    s_char,
    s_char_matrices,
    s_char_matricespells
} from "../../_signals/s_char";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import {ICharMatrice} from "../../_interfaces/ICharMatrice";
import {ResultsAdd} from "../../_api/BEResult";
import {IResult} from "../../_interfaces/IResult";
import {charModsGetMod} from "../../_sig_api/charMods";
import {ICharMatriceSpell} from "../../_interfaces/ICharMatriceSpell";
import {MatricespellsUpdate} from "../../_api/BEMatricespells";
import {getWavingTalent} from "./getWeavingTalent";
import {IRollerResult} from "../../_interfaces/IRoller";
import Button from "@mui/material/Button";
import {IDataSpell} from "../../_interfaces/IDataSpell";
import {SpellsSubscriber} from "../../_helper/DataBehaves";
import {s_app_rid, s_app_sl} from "../../_signals/s_app";

interface IProp {
    weave: string
    isOpen: (open: boolean) => void
}

function MatriceSpellWeaving({weave, isOpen}: IProp) {

    const mod_rank = [...Array(16).keys()];

    const [weaveOpen, setWeaveOpen] = useState(false)
    const [weavingMatrice, setWeavingMatrice] = useState<ICharMatrice | null>(null)
    const [weavingResult, setWeavingResult] = useState<IRollerResult | null>(null)
    const [weavingTalent, setWeavingTalent] = useState<ICharTalent | null>(null)
    const [weavingSpell, setWeavingSpell] = useState<ICharMatriceSpell | null>(null)
    const [weavingMod, setWeavingMod] = useState(0)
    const [weavingKarma, setWeavingKarma] = useState(false)
    const [usedSpell, setUsedSpell] = useState<IDataSpell | null>(null)

    useEffect(() => {
        if (!weave) {
            setWeaveOpen(false);
        } else {
            let mspell = s_char_matricespells.value.find((s) => s.id === weave);
            if (!mspell) return;
            let spell = SpellsSubscriber.value.find((s) => s.name === mspell?.name);
            if (!spell)  setUsedSpell(null)
            else setUsedSpell(spell)
            if (!spell) return;
            let weaving = getWavingTalent(spell.discipline);
            let matrice = s_char_matrices.value.find(m => m.id === mspell?.mid);
            if (weaving && matrice) {
                setWeavingTalent(weaving);
                setWeavingMod(0);
                setWeavingKarma(false);
                setWeavingMatrice(matrice);
                setWeavingSpell(mspell);
                setWeavingResult(null);
                setWeaveOpen(true);
            } else {
                alert('kein ' + spell.discipline + ' gefunden');
            }
        }
    }, [weave])

    const weaveRoll = () => {
        if (!weavingSpell || !weavingTalent) return
        let step = s_char_attr_step(weavingTalent.attribute).value;
        step = step + weavingTalent.step
        step = step + weavingMod
        step = step + charModsGetMod(s_char.value.id, weavingTalent.attribute);

        const rolled = rollStep(step, weavingKarma, weavingSpell.weavediff);

        setWeavingResult(rolled)
        rollerSetRolled(true)

        let rolledResult: IResult = {
            title: 'Fadenweben ' + weavingSpell.name,
            result: rolled.result,
            karma: rolled.karma,
            name: s_char.value.name,
            nsc: s_char.value.nsc,
            rid: s_app_rid.value,
            rollas: rolled.as,
            rolled: rolled.rolled,
            rollvs: rolled.vsnum,
            sl: s_app_sl.value,
            step: rolled.step,
            step_mod: rolled.step_mod,
            success: rolled.success,
            successes: rolled.successes,
            time: rolled.time,
            id: v4(),
            cid: s_char.value.id,
            eff: '',
            addEff: '',
        };

        ResultsAdd(rolledResult);
    }

    const weaveAssign = () => {
        if (!weavingSpell || !weavingResult || !weavingMatrice) return

        if (weavingResult.result >= weavingSpell.weavediff) {
            let matricespells = s_char_matricespells.value;
            const f = matricespells.findIndex((m) => m.id === weavingSpell.id);
            if (f >= 0) {
                // TODO mehrere auf einmal? mit knack oder anderen fadenweben talent?
                matricespells[f].threadswoven = matricespells[f].threadswoven + 1;
                console.log('weaveAssign update', matricespells[f])
                MatricespellsUpdate(matricespells[f])
                s_char_matricespells.value = matricespells;
            }
        }
        weaveClose();
    }

    const weaveClose = () => {
        setWeaveOpen(false)
        isOpen(false)
    }


    return <Dialog open={weaveOpen} fullWidth={true} maxWidth={'xl'}>
        <DialogTitle>Fäden weben ({weavingSpell?.name})</DialogTitle>
        <DialogContent>
            <div>für Zauber: {weavingSpell?.name}</div>
            <div>gegen Schwierigkeit: {weavingSpell?.weavediff}</div>
            <div>mit: {weavingTalent?.name} Stufe: {weavingTalent?.step} + {weavingTalent?.attribute}</div>
            <div>
                {weavingTalent?.karma ? <FormControlLabel
                    label="Karma"
                    control={
                        <Checkbox
                            checked={weavingKarma}
                            onChange={(e) => setWeavingKarma(e.target.checked)}
                        />
                    }
                /> : null}
                <Select key={v4()}
                        value={weavingMod}
                        onChange={(e) => setWeavingMod(e.target.value as number)}
                >
                    <ListSubheader>Modifikator</ListSubheader>
                    {mod_rank.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                </Select>
            </div>

            {weavingSpell && usedSpell && usedSpell.at?<Fragment>
                <div>Zusätzliche Fäden: ({(weavingSpell.threadswoven - weavingSpell.threads)>0?weavingSpell.threadswoven - weavingSpell.threads:'noch keine'}) verwendbar für</div>
                {usedSpell.at.map((at, i) => <div>{at.txt}</div>)}
            </Fragment>:null}


            <Button onClick={() => weaveRoll()}>würfeln</Button>
            {weavingSpell && weavingResult ? <div>
                    <hr/>
                    <Typography variant="h6" gutterBottom>
                        Ergebnis
                    </Typography>
                    <div>Stufe: {weavingResult.step} Ergebnis: {weavingResult.result}</div>
                    <div>Gewürfelt: {weavingResult.rolled} {displayMod(weavingResult.step_mod)}
                        {weavingResult.karma ? ' Karma ' + weavingResult.karma : ''}
                    </div>
                    {weavingResult.result >= weavingSpell.weavediff ?
                        <Button onClick={() => weaveAssign()}>ok</Button> : null}
                </div>
                : null}

        </DialogContent>
        <DialogActions>
            <Button onClick={() => weaveClose()}>abbruch</Button>
        </DialogActions>
    </Dialog>
}

export default MatriceSpellWeaving;
